export default {
  getCntAccKeyDetails: state => state.cnt,
  getGridDataAccKeyDetails: state => state.gridData,
  getSearchParamAccKeyDetails: state => state.searchParam,
  getProjectListAccKeyDetails: state => state.projectList,
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/details/accKeyDetailsGetter.js